if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.enableMobileTapAdvance();
        this.enableDesktopGalleryArrows();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        this.syncViewerArrowState();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }


      enableMobileTapAdvance() {
        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'click',
          (event) => {
            if (this.mql.matches) return;
            if (
              event.target.closest(
                '.slider-button, deferred-media, product-model, .deferred-media__poster, .product__xr-button, .thumbnail-list, a'
              )
            ) {
              return;
            }

            const opener = event.target.closest('.product__modal-opener--image');
            if (!opener) return;

            // Only intercept when zoom is disabled (Dawn "none")
            if (!opener.querySelector('.product__media-zoom-none')) return;

            event.preventDefault();
            event.stopPropagation();

            const nextButton = this.elements.viewer.querySelector('.slider-button--next');
            const prevButton = this.elements.viewer.querySelector('.slider-button--prev');
            if (nextButton && !nextButton.hasAttribute('disabled')) {
              nextButton.click();
              return;
            }
            if (prevButton) {
              // Wrap to first image when at the end
              const slider = this.elements.viewer.slider || this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
              if (slider) slider.scrollTo({ left: 0 });
            }
          },
          true
        );
      }

      getViewerMediaItems() {
        if (!this.elements.viewer) return [];
        return Array.from(
          this.elements.viewer.querySelectorAll('.product__media-list .product__media-item[data-media-id]')
        );
      }

      positionDesktopArrowOverlay() {
        const buttons = this.elements.viewer && this.elements.viewer.querySelector(':scope > .slider-buttons');
        if (!buttons) return;

        if (!this.mql.matches) {
          buttons.style.top = '';
          buttons.style.left = '';
          buttons.style.width = '';
          buttons.style.height = '';
          buttons.style.right = '';
          buttons.style.bottom = '';
          return;
        }

        const activeMedia =
          this.elements.viewer.querySelector('.product__media-item.is-active .product-media-container') ||
          this.elements.viewer.querySelector('.product__media-item.is-active');
        if (!activeMedia) return;

        const viewerRect = this.elements.viewer.getBoundingClientRect();
        const mediaRect = activeMedia.getBoundingClientRect();

        buttons.style.top = `${Math.max(0, mediaRect.top - viewerRect.top)}px`;
        buttons.style.left = `${Math.max(0, mediaRect.left - viewerRect.left)}px`;
        buttons.style.width = `${mediaRect.width}px`;
        buttons.style.height = `${mediaRect.height}px`;
        buttons.style.right = 'auto';
        buttons.style.bottom = 'auto';
      }

      syncViewerArrowState() {
        if (!this.elements.viewer) return;
        const buttons = this.elements.viewer.querySelector(':scope > .slider-buttons');
        if (!buttons) return;

        const prevButton = buttons.querySelector('.slider-button--prev');
        const nextButton = buttons.querySelector('.slider-button--next');
        const counter = buttons.querySelector('.slider-counter--current');
        if (!prevButton || !nextButton) return;

        this.positionDesktopArrowOverlay();

        const items = this.getViewerMediaItems();
        const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
        if (activeIndex < 0 || items.length < 2) {
          prevButton.setAttribute('disabled', 'disabled');
          nextButton.setAttribute('disabled', 'disabled');
          return;
        }

        if (activeIndex <= 0) prevButton.setAttribute('disabled', 'disabled');
        else prevButton.removeAttribute('disabled');

        if (activeIndex >= items.length - 1) nextButton.setAttribute('disabled', 'disabled');
        else nextButton.removeAttribute('disabled');

        if (counter) counter.textContent = String(activeIndex + 1);
      }

      enableDesktopGalleryArrows() {
        if (!this.elements.viewer) return;
        if (!this.dataset.desktopLayout || !this.dataset.desktopLayout.includes('thumbnail')) return;

        const buttons = this.elements.viewer.querySelector(':scope > .slider-buttons');
        if (!buttons) return;

        const prevButton = buttons.querySelector('.slider-button--prev');
        const nextButton = buttons.querySelector('.slider-button--next');
        if (!prevButton || !nextButton) return;

        const onArrowClick = (event) => {
          // Mobile keeps Dawn slider scroll / existing behaviour
          if (!this.mql.matches) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const items = this.getViewerMediaItems();
          if (items.length < 2) return;

          const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
          if (activeIndex < 0) return;

          const delta = event.currentTarget.name === 'next' ? 1 : -1;
          const nextIndex = activeIndex + delta;
          if (nextIndex < 0 || nextIndex >= items.length) return;

          this.setActiveMedia(items[nextIndex].dataset.mediaId, false);
        };

        prevButton.addEventListener('click', onArrowClick, true);
        nextButton.addEventListener('click', onArrowClick, true);

        this.mql.addEventListener('change', () => this.syncViewerArrowState());
        window.addEventListener(
          'resize',
          debounce(() => this.positionDesktopArrowOverlay(), 150)
        );
        // After slider-component finishes its own control init + images layout
        window.setTimeout(() => this.syncViewerArrowState(), 0);
        window.setTimeout(() => this.positionDesktopArrowOverlay(), 300);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
